var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7074 5.29279C14.8949 5.48031 15.0002 5.73462 15.0002 5.99979C15.0002 6.26495 14.8949 6.51926 14.7074 6.70679L9.41441 11.9998L14.7074 17.2928C14.8029 17.385 14.8791 17.4954 14.9315 17.6174C14.9839 17.7394 15.0115 17.8706 15.0127 18.0034C15.0138 18.1362 14.9885 18.2678 14.9382 18.3907C14.8879 18.5136 14.8137 18.6253 14.7198 18.7192C14.6259 18.8131 14.5143 18.8873 14.3914 18.9376C14.2685 18.9879 14.1368 19.0132 14.004 19.012C13.8712 19.0109 13.74 18.9833 13.618 18.9309C13.496 18.8785 13.3857 18.8023 13.2934 18.7068L7.29341 12.7068C7.10593 12.5193 7.00062 12.265 7.00062 11.9998C7.00062 11.7346 7.10593 11.4803 7.29341 11.2928L13.2934 5.29279C13.4809 5.10532 13.7352 5 14.0004 5C14.2656 5 14.5199 5.10532 14.7074 5.29279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWhiteIcon);
export default __webpack_public_path__ + "static/media/back-white-icon.f8dfadc6a897f93c525c5c456549ee53.svg";
export { ForwardRef as ReactComponent };